
import { HeroSection } from "@/components/for-pros/HeroSection";
import { BenefitsSection } from "@/components/for-pros/BenefitsSection";
import { ContactForm } from "@/components/for-pros/ContactForm";
import { ClaimSection } from "@/components/for-pros/ClaimSection";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Calculator, ArrowRight } from "lucide-react";
import { useRef } from "react";

const ForPros = () => {
  const breadcrumbItems = [
    { label: "For Pros" }
  ];

  const contactFormRef = useRef<HTMLDivElement>(null);

  const scrollToForm = () => {
    contactFormRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen relative">
      <HeroSection />
      <div className="container mx-auto px-4">
        <Breadcrumbs items={breadcrumbItems} />
        
        {/* Primary CTA - Submit Business Form */}
        <div className="mb-16" ref={contactFormRef}>
          <ContactForm />
        </div>
        
        {/* Benefits Section */}
        <BenefitsSection />
        
        {/* Claim Business Section */}
        <ClaimSection />
        
        {/* Tools Section */}
        <div className="grid md:grid-cols-2 gap-8 my-16">
          <div className="p-6 bg-gradient-to-r from-primary/10 to-primary/5 rounded-lg text-center">
            <h2 className="text-2xl font-bold mb-4 text-primary">Calculate Your Lead Value</h2>
            <p className="mb-6 text-muted-foreground">
              Use our Lead Value Calculator to estimate potential revenue and profit from your leads.
            </p>
            <Link to="/lead-calculator">
              <Button className="bg-primary hover:bg-primary/90">
                <Calculator className="mr-2 h-4 w-4" />
                Try Our Lead Calculator
              </Button>
            </Link>
          </div>
          
          <div className="p-6 bg-gradient-to-r from-primary/10 to-primary/5 rounded-lg text-center">
            <h2 className="text-2xl font-bold mb-4 text-primary">Trust Badge for Your Website</h2>
            <p className="mb-6 text-muted-foreground">
              Display your Home Pros OKC membership on your website with our official badge.
            </p>
            <Link to="/badge-info">
              <Button className="bg-primary hover:bg-primary/90">
                Learn More About Trust Badges
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {/* Floating CTA Button */}
      <div className="fixed bottom-8 right-8 z-50">
        <Button 
          onClick={scrollToForm}
          size="lg"
          className="bg-primary hover:bg-primary/90 shadow-lg hover:shadow-xl transition-all duration-200 font-semibold"
        >
          Get Listed Today <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default ForPros;
